module.exports = __webpack_public_path__ + "static/media/bennett.32e61c21.png";